/** @jsx jsx */
import { jsx, ThemeUIStyleObject } from '@theme-ui/core';
import { Children } from 'react';

type SxPropertyWithNumber = number | string | (number | string | null)[];
type SxProperty = string | (string | null)[];
type StackProps = {
    children: React.ReactNode;
    space: SxPropertyWithNumber;
    sx?: ThemeUIStyleObject;
};

export function Stack({ children, space, ...props }: StackProps) {
    const items = Children.toArray(children);

    return (
        <div {...props}>
            {items.map((item, index) => (
                <div
                    key={index}
                    sx={{
                        marginTop: index === 0 ? undefined : space,
                    }}
                >
                    {item}
                </div>
            ))}
        </div>
    );
}

type BorderStackProps = {
    children: React.ReactNode;
    borderY?: SxPropertyWithNumber;
    borderInner?: SxPropertyWithNumber;
    borderColor?: SxProperty;
    borderYWidth?: SxPropertyWithNumber;
    paddingY?: SxPropertyWithNumber;
};

export function BorderStack({
    children,
    borderY,
    borderInner = borderY,
    borderColor,
    borderYWidth,
    paddingY,
    ...props
}: BorderStackProps) {
    const elements = Children.toArray(children);

    return (
        <div {...props}>
            {elements.map((item, index) => (
                <div
                    key={index}
                    sx={{
                        borderTop: index === 0 ? borderY : undefined,
                        borderBottom: index === elements.length ? borderY : borderInner,
                        borderColor,
                        borderTopWidth: borderYWidth,
                        borderBottomWidth: borderYWidth,
                        paddingY,
                    }}
                >
                    {item}
                </div>
            ))}
        </div>
    );
}
